<div class="col-12">
  <span class="error-message" tmwTranslate="global.list.no-item.search-error">No matching results found for your search</span>
</div>
